import { Route, Routes } from 'react-router-dom';
import { AuthProvider, RequireRole } from './lib/auth';
import { ToastProvider } from './components/ui';
import { PublicLayout } from './layouts/PublicLayout';
import { AdminLayout } from './layouts/AdminLayout';

import { HomePage } from './pages/public/HomePage';
import { ArticlePage } from './pages/public/ArticlePage';
import { CategoryPage } from './pages/public/CategoryPage';
import { SearchPage } from './pages/public/SearchPage';
import { StaticPages } from './pages/public/StaticPages';
import { NotFoundPage } from './pages/public/NotFoundPage';

import { LoginPage } from './pages/admin/LoginPage';
import { DashboardPage } from './pages/admin/DashboardPage';
import { ArticlesListPage } from './pages/admin/ArticlesListPage';
import { ArticleEditorPage } from './pages/admin/ArticleEditorPage';
import { CategoriesPage } from './pages/admin/CategoriesPage';
import { MediaPage } from './pages/admin/MediaPage';
import { TeamPage } from './pages/admin/TeamPage';
import { SettingsPage } from './pages/admin/SettingsPage';
import { AuditPage, AnalyticsPage, AdsPage } from './pages/admin/OpsPages';

export function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route index element={<HomePage />} />
            <Route path="article/:slug" element={<ArticlePage />} />
            <Route path="category/:slug" element={<CategoryPage />} />
            <Route path="search" element={<SearchPage />} />
            <Route path="latest" element={<StaticPages kind="latest" />} />
            <Route path="trending" element={<StaticPages kind="trending" />} />
            <Route path="about" element={<StaticPages kind="about" />} />
            <Route path="contact" element={<StaticPages kind="contact" />} />
            <Route path="advertise" element={<StaticPages kind="advertise" />} />
            <Route path="terms" element={<StaticPages kind="terms" />} />
            <Route path="privacy" element={<StaticPages kind="privacy" />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>

          <Route path="/admin/login" element={<LoginPage />} />

          <Route
            path="/admin"
            element={
              <RequireRole allow={['admin', 'editor', 'writer', 'analyst', 'seo_manager', 'social_manager']}>
                <AdminLayout />
              </RequireRole>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="articles" element={<ArticlesListPage />} />
            <Route path="articles/new" element={<ArticleEditorPage />} />
            <Route path="articles/:id" element={<ArticleEditorPage />} />
            <Route path="categories" element={<CategoriesPage />} />
            <Route path="media" element={<MediaPage />} />
            <Route path="team" element={<TeamPage />} />
            <Route path="audit" element={<AuditPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="ads" element={<AdsPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </ToastProvider>
    </AuthProvider>
  );
}
